import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { getMainConfig, getBannerLinks, getPageContent } from './admin/apiCalls';
import { store, StateProvider } from '../Store';
import LoadingSpinner from './LoadingSpinner';
import configAdmin from './admin/configAdmin.json';

export default function WavesBanner() {

  const { WEB_FOLDER } = window.config;
  const { HOMEPAGE_CODE } = configAdmin

  const [title, setTitle] = useState('');
  const [bannerLinks, setBannerLinks] = useState([]);
  const [textContent, setTextContent] = useState({});
  const { state, dispatch } = useContext(store);

  const colorThemes = {
    'green': '#5AA39E',
    'green-2': '#3B5611',
    'coffe': '#6e6362ff',
    'red': '#AE1919',
    'blue': '#0A1931',
    'light-blue': '#3583C0'
  }

  const styleTheme = {
    'subsubtitle': `${state?.configData && state.configData.theme}-subsubtitle`,
    'wavesColor': state?.configData && state.configData.theme ? colorThemes[state.configData.theme] : '#5AA39E'
  }

  useEffect(() => {
    getMainConfig(setTitle);
    getBannerLinks(setBannerLinks);
    getPageContent(setTextContent, HOMEPAGE_CODE);
  }, []);
  

  const staticImages = {
      backgroundBanner: `${WEB_FOLDER}/uploads/bg.jpg`
  };

  const wavesContent = (
    <div style={{width: '100%', position: 'relative'}}>
        {/*<img src={'img/waves.svg'} className='waves-top waves-banner-img' alt="Inicio" />*/}

        <div className='waves-banner-img waves-top'>
        <svg viewBox="0 0 300 109" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%">
        <g transform="matrix(0.1, 0, 0, -0.1, 0, 109)" fill="#ffffff" stroke="none">
        <path d="M -80.387 1156.359 C -80.638 1156.3 0.075 1069.315 0.075 1069.315 C 0.075 1064.315 -0.523 1042.523 -0.523 1011.523 C -0.523 1008.523 138 1005 308 1004 C 735 1003 985 973 1382 871 C 1656 801 1725 789 1897 783 C 2108 775 2380 809 2540 864 C 2565 873 3036.306 1026.004 3022.306 1023.004 C 3018.388 1022.164 3084.122 1087.147 2978.46 1095.103 C 2706.583 1115.575 2075.751 1094.99 1958.37 1100.031 C 1744.37 1109.031 1771.627 1219.778 1464.627 1297.778 C 972.627 1423.778 535.772 1265.016 182.772 1269.016 C 50.772 1270.016 -54.387 1159.359 -80.387 1156.359 Z"/>
        </g>
        </svg>
        </div>

        <div className='waves-banner-img waves-top'>
        <svg viewBox="0 0 300 109" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" width="100%" height="100%">
        <g transform="matrix(0.1, 0, 0, -0.1, 0, 109)" fill={styleTheme.wavesColor} stroke="none">
            <path d="M 0.204 1072.783 C -0.047 1072.724 0.075 1069.315 0.075 1069.315 C 0.075 1064.315 -0.523 1042.523 -0.523 1011.523 C -0.523 1008.523 138 1005 308 1004 C 735 1003 985 973 1382 871 C 1656 801 1725 789 1897 783 C 2108 775 2380 809 2540 864 C 2565 873 2743.623 924.563 2729.623 921.563 C 2715.623 918.563 2492 861 2440 850 C 2283 818 2138 807 1975 814 C 1761 823 1653 841 1346 919 C 854 1045 688 1071 335 1075 C 203 1076 26.204 1075.783 0.204 1072.783 Z"/>
        </g>
        </svg>
        </div>

        <img src={ staticImages.backgroundBanner } className='waves-banner-img waves-banner-bg' alt="Inicio" />

        <span className="waves-banner-title"><h1>{ textContent?.title && textContent.title }</h1></span>

    </div>
  )

  return (
    <>
      { title !== '' ? wavesContent : <LoadingSpinner /> }
    </>
  )

}
